import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ## Make React Router to go on top of a page when transition occurs
 * It looks for `title` id on page. If none it does nothing.
 * Also, it does that only if the url doesn't contain a hash
 * @example
 * /realisation#toto => does nothing
 * /realisation => Goes to top
 *
 * @returns null
 */
function ScrollTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash.length === 0) {
      document.getElementById('title')?.scrollIntoView();
    }
  }, [pathname, hash]);

  return null;
}

export default ScrollTop;
